/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../design-system/settings/variables/Colors';
import { SPACERS } from '../design-system/settings/variables/Spacers';
import TrueImpactText from '../design-system/base/TrueImpactText';

export const IrCustomQuestions = ({ data }) => {
  const formatResponse = (response) => {
    if (Array.isArray(response)) {
      return response.join(', ');
    }
    if (typeof response === 'object' && response !== null) {
      return JSON.stringify(response);
    }
    return response || 'Not specified';
  };

  const customQuestions = () => {
    if (data && typeof data === 'object') {
      return Object.keys(data).map((question, index) => {
        const response = formatResponse(data[question]);
        return (
          <RowDiv key={index}>
            <TrueImpactText variant="body-small-bold">
              {question}
            </TrueImpactText>
            <TrueImpactText variant="body-small">
              {response}
            </TrueImpactText>
          </RowDiv>
        );
      });
    }
    return null;
  };

  if (!data || typeof data !== 'object' || Object.keys(data).length === 0) {
    return null;
  }

  return (
    <StyledDiv>
      <TrueImpactText
        variant="heading-subheading"
        className="custom-questions-header"
      >
        Custom Questions
      </TrueImpactText>
      {customQuestions()}
    </StyledDiv>
  );
};

const StyledDiv = styled.div`
  background-color: ${COLORS.whiteBase};
  padding-top: ${SPACERS.large};
  padding-bottom: ${SPACERS.large};
  .custom-questions-header {
    padding-left: ${SPACERS.extraLarge};
    padding-right: ${SPACERS.extraLarge};
    padding-bottom: ${SPACERS.tiny};
  }
`;

const budgetTableGridStyles = `
  display: grid;
  gap: ${SPACERS.small};
  align-items: center;
  grid-template-columns: 1fr 3fr;
  padding: ${SPACERS.small} ${SPACERS.extraLarge};
`;

const RowDiv = styled.div`
  ${budgetTableGridStyles}
  border-top: 1px solid ${COLORS.grayLight};
`;
